/**
 * Testimonials Section — Judge.me Widget API + Swiper Carousel
 *
 * Supports two modes:
 *   1. Product page: fetches product-specific reviews via product_review widget,
 *      falls back to store-wide featured_carousel if product has no reviews.
 *   2. Non-product page (homepage): fetches store-wide featured_carousel directly.
 *
 * Trust badge is hydrated with live data from Judge.me API.
 */
(function () {
  function escapeHTML(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function initTestimonialsSection(section) {
    var sectionId = section.dataset.sectionId;
    var apiToken = section.dataset.apiToken;
    var shopDomain = section.dataset.shopDomain;
    var minRating = parseInt(section.dataset.minRating, 10) || 4;
    var maxReviews = parseInt(section.dataset.reviewsCount, 10) || 10;
    var productHandle = section.dataset.productHandle || '';
    var swiperContainer = section.querySelector('.testimonials-swiper-' + sectionId);
    var swiperWrapper = swiperContainer ? swiperContainer.querySelector('.swiper-wrapper') : null;
    var activeSwiper = null;

    if (!apiToken || !shopDomain || !swiperWrapper) return;

    function initSwiper() {
      if (typeof Swiper === 'undefined' || !swiperContainer) return;

      var slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;
      if (slideCount < 1) return;

      if (activeSwiper) {
        activeSwiper.destroy(true, true);
        activeSwiper = null;
      }

      activeSwiper = new Swiper(swiperContainer, {
        slidesPerView: 1.15,
        spaceBetween: 14,
        grabCursor: true,
        watchOverflow: true,
        pagination: {
          el: '.tm-pagination-' + sectionId,
          type: 'progressbar'
        },
        navigation: {
          prevEl: '.tm-prev-' + sectionId,
          nextEl: '.tm-next-' + sectionId
        },
        breakpoints: {
          480: { slidesPerView: 1.4, spaceBetween: 14 },
          640: { slidesPerView: 2.2, spaceBetween: 16 },
          1024: { slidesPerView: 3, spaceBetween: 20 },
          1280: { slidesPerView: 3.15, spaceBetween: 20 }
        }
      });
    }

    function waitForSwiper(callback) {
      if (typeof Swiper !== 'undefined') { callback(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        if (typeof Swiper !== 'undefined') { clearInterval(poll); callback(); }
        else if (attempts > 50) { clearInterval(poll); }
      }, 100);
    }

    function buildStarsHTML(rating) {
      var html = '<div class="testimonials__stars">';
      for (var i = 1; i <= 5; i++) {
        html += '<svg class="testimonials__star' + (i <= rating ? ' testimonials__star--filled' : '') +
          '" viewBox="0 0 20 20" width="18" height="18"><path d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.49L10 13.77 5.06 16.7l.94-5.49-4-3.9 5.53-.8L10 1.5z"/></svg>';
      }
      html += '</div>';
      return html;
    }

    function buildCardHTML(review) {
      var initial = review.name ? escapeHTML(review.name.charAt(0).toUpperCase()) : '?';
      var html = '<div class="swiper-slide"><div class="testimonials__card">';

      html += buildStarsHTML(review.rating);

      if (review.title) {
        html += '<h3 class="testimonials__card-title">' + escapeHTML(review.title) + '</h3>';
      }

      html += '<p class="testimonials__card-body">' + escapeHTML(review.body) + '</p>';

      html += '<div class="testimonials__author">';
      html += '<div class="testimonials__avatar">' + initial + '</div>';
      html += '<div class="testimonials__author-info">';
      html += '<div class="testimonials__author-row">';
      html += '<span class="testimonials__author-name">' + escapeHTML(review.name) + '</span>';
      html += '<span class="testimonials__verified">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="7" fill="currentColor"/>' +
        '<path d="M4 7l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        ' Verified</span>';
      html += '</div>';

      if (review.date) {
        html += '<span class="testimonials__date">' + escapeHTML(review.date) + '</span>';
      }

      html += '</div></div>';
      html += '</div></div>';
      return html;
    }

    /**
     * Parse Judge.me featured_carousel widget HTML (store-wide reviews).
     * Uses .jdgm-carousel-item class.
     */
    function parseCarouselHTML(htmlString) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(htmlString, 'text/html');
      var reviews = [];

      var items = doc.querySelectorAll('.jdgm-carousel-item');

      items.forEach(function (el) {
        var stars = el.querySelectorAll('.jdgm-star');
        var rating = 0;
        stars.forEach(function (star) {
          if (star.classList.contains('jdgm--on')) rating++;
        });
        if (rating === 0) {
          var ratingEl = el.querySelector('.jdgm-carousel-item__review-rating');
          if (ratingEl) {
            var ariaLabel = ratingEl.getAttribute('aria-label') || '';
            var match = ariaLabel.match(/(\d)/);
            if (match) rating = parseInt(match[1], 10);
          }
        }
        if (rating === 0) rating = 5;

        var bodyEl = el.querySelector('.jdgm-carousel-item__review-body');
        var body = '';
        if (bodyEl) {
          var pEl = bodyEl.querySelector('p');
          body = (pEl || bodyEl).textContent.trim();
        }

        var nameEl = el.querySelector('.jdgm-carousel-item__reviewer-name');
        var name = nameEl ? nameEl.textContent.trim() : 'Customer';

        var dateEl = el.querySelector('.jdgm-carousel-item__timestamp');
        var date = '';
        if (dateEl) {
          var rawDate = dateEl.getAttribute('data-time') || dateEl.textContent.trim();
          try {
            var d = new Date(rawDate);
            if (!isNaN(d.getTime())) {
              date = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
            } else {
              date = rawDate;
            }
          } catch (e) { date = rawDate; }
        }

        var reviewTitleEl = el.querySelector('.jdgm-carousel-item__review-title');
        var title = reviewTitleEl ? reviewTitleEl.textContent.trim() : '';
        if (!title) {
          var productTitleEl = el.querySelector('.jdgm-carousel-item__product-title');
          title = productTitleEl ? productTitleEl.textContent.trim() : '';
        }

        if (body) {
          reviews.push({ rating: rating, name: name, title: title, body: body, date: date });
        }
      });

      return reviews;
    }

    /**
     * Parse Judge.me product_review widget HTML (product-specific reviews).
     * Uses .jdgm-rev class. Also extracts aggregate rating/count.
     */
    function parseProductReviewHTML(htmlString) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(htmlString, 'text/html');
      var reviews = [];
      var aggregate = { rating: null, count: null };

      // Extract aggregate rating from summary
      var summaryStars = doc.querySelector('.jdgm-rev-widg__summary-stars');
      if (summaryStars) {
        var ariaLabel = summaryStars.getAttribute('aria-label') || '';
        var ratingMatch = ariaLabel.match(/([\d.]+)\s*stars/);
        if (ratingMatch) aggregate.rating = ratingMatch[1];
      }
      var summaryText = doc.querySelector('.jdgm-rev-widg__summary-text');
      if (summaryText) {
        var countMatch = summaryText.textContent.match(/(\d+)\s*review/);
        if (countMatch) aggregate.count = countMatch[1];
      }

      // Parse individual reviews
      var items = doc.querySelectorAll('.jdgm-rev');

      items.forEach(function (el) {
        // Rating from data-score or star count
        var ratingEl = el.querySelector('.jdgm-rev__rating');
        var rating = 0;
        if (ratingEl) {
          var score = ratingEl.getAttribute('data-score');
          if (score) {
            rating = parseInt(score, 10);
          } else {
            var stars = ratingEl.querySelectorAll('.jdgm-star.jdgm--on');
            rating = stars.length;
          }
        }
        if (rating === 0) rating = 5;

        // Review body
        var bodyEl = el.querySelector('.jdgm-rev__body');
        var body = '';
        if (bodyEl) {
          var pEl = bodyEl.querySelector('p');
          body = (pEl || bodyEl).textContent.trim();
        }

        // Reviewer name
        var nameEl = el.querySelector('.jdgm-rev__author');
        var name = nameEl ? nameEl.textContent.trim() : 'Customer';

        // Date
        var dateEl = el.querySelector('.jdgm-rev__timestamp');
        var date = '';
        if (dateEl) {
          var rawDate = dateEl.getAttribute('data-content') || dateEl.textContent.trim();
          try {
            var d = new Date(rawDate);
            if (!isNaN(d.getTime())) {
              date = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
            } else {
              date = rawDate;
            }
          } catch (e) { date = rawDate; }
        }

        // Review title
        var titleEl = el.querySelector('.jdgm-rev__title');
        var title = titleEl ? titleEl.textContent.trim() : '';

        if (body) {
          reviews.push({ rating: rating, name: name, title: title, body: body, date: date });
        }
      });

      return { reviews: reviews, aggregate: aggregate };
    }

    function removeSkeleton() {
      var skeletons = swiperWrapper.querySelectorAll('[data-skeleton]');
      skeletons.forEach(function (s) { s.remove(); });
    }

    function renderReviews(reviews) {
      removeSkeleton();
      var html = '';
      reviews.forEach(function (review) {
        html += buildCardHTML(review);
      });
      swiperWrapper.innerHTML = html;
    }

    function showError() {
      removeSkeleton();
      swiperWrapper.innerHTML =
        '<div class="swiper-slide"><div class="testimonials__card" style="text-align:center;justify-content:center;">' +
        '<p class="testimonials__card-body" style="opacity:0.5;">Reviews are loading — check back shortly.</p>' +
        '</div></div>';
    }

    function updateTrustBadge(rating, count) {
      var ratingEl = section.querySelector('[data-badge-rating]');
      var countEl = section.querySelector('[data-badge-count]');
      if (ratingEl && rating) ratingEl.textContent = rating;
      if (countEl && count) countEl.textContent = formatNumber(parseInt(count, 10));
    }

    /**
     * Fetch store-wide reviews (homepage behavior).
     * Uses featured_carousel + all_reviews_rating + all_reviews_count widgets.
     */
    function fetchStoreReviews() {
      var base = 'https://judge.me/api/v1/widgets/';
      var params = '?api_token=' + encodeURIComponent(apiToken) + '&shop_domain=' + encodeURIComponent(shopDomain);

      Promise.all([
        fetch(base + 'featured_carousel' + params).then(function (r) { return r.ok ? r.json() : null; }),
        fetch(base + 'all_reviews_rating' + params).then(function (r) { return r.ok ? r.json() : null; }),
        fetch(base + 'all_reviews_count' + params).then(function (r) { return r.ok ? r.json() : null; })
      ]).then(function (results) {
        var carouselData = results[0];
        var ratingData = results[1];
        var countData = results[2];

        if (ratingData && ratingData.all_reviews_rating) {
          updateTrustBadge(ratingData.all_reviews_rating, null);
        }
        if (countData && countData.all_reviews_count) {
          updateTrustBadge(null, countData.all_reviews_count);
        }

        if (carouselData && carouselData.featured_carousel) {
          var reviews = parseCarouselHTML(carouselData.featured_carousel);
          reviews = reviews.filter(function (r) { return r.rating >= minRating; });
          reviews = reviews.slice(0, maxReviews);

          if (reviews.length > 0) {
            renderReviews(reviews);
          } else {
            showError();
          }
        } else {
          showError();
        }

        waitForSwiper(initSwiper);
      }).catch(function () {
        showError();
        waitForSwiper(initSwiper);
      });
    }

    /**
     * Fetch product-specific reviews, with fallback to store-wide.
     * Uses product_review widget with handle param.
     */
    function fetchProductReviews() {
      var base = 'https://judge.me/api/v1/widgets/';
      var params = '?api_token=' + encodeURIComponent(apiToken) + '&shop_domain=' + encodeURIComponent(shopDomain);

      fetch(base + 'product_review' + params + '&handle=' + encodeURIComponent(productHandle))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data && data.widget) {
            var result = parseProductReviewHTML(data.widget);
            var reviews = result.reviews;

            // Update trust badge with product-specific aggregate data
            if (result.aggregate.rating) {
              updateTrustBadge(result.aggregate.rating, null);
            }
            if (result.aggregate.count) {
              updateTrustBadge(null, result.aggregate.count);
            }

            // Filter and limit
            reviews = reviews.filter(function (r) { return r.rating >= minRating; });
            reviews = reviews.slice(0, maxReviews);

            if (reviews.length > 0) {
              renderReviews(reviews);
              waitForSwiper(initSwiper);
              return;
            }
          }

          // Fallback: no product reviews found, use store-wide
          fetchStoreReviews();
        })
        .catch(function () {
          // Fallback on error
          fetchStoreReviews();
        });
    }

    // In design mode, show preview placeholder (API reviews render on live storefront)
    if (window.Shopify && Shopify.designMode) {
      removeSkeleton();
      var placeholders = '';
      for (var p = 0; p < 4; p++) {
        placeholders += '<div class="swiper-slide"><div class="testimonials__card" style="text-align:center;justify-content:center;opacity:0.5;">' +
          buildStarsHTML(5) +
          '<p class="testimonials__card-body" style="opacity:0.7;">Judge.me reviews load automatically on the live storefront.</p>' +
          '</div></div>';
      }
      swiperWrapper.innerHTML = placeholders;
      waitForSwiper(initSwiper);
    } else if (productHandle) {
      fetchProductReviews();
    } else {
      fetchStoreReviews();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-section-id]').forEach(function (el) {
      if (el.querySelector('[class*="testimonials-swiper-"]')) {
        initTestimonialsSection(el);
      }
    });
    initReviewModal();
  }

  /**
   * Build SVG star rating overlay that syncs with Judge.me's hidden rating input.
   * Judge.me v3 blanks the icon font stars, so we render our own.
   */
  function buildStarOverlay(formWrap) {
    if (!formWrap || formWrap.querySelector('.testimonials-review-modal__stars-overlay')) return;

    var ratingFieldset = formWrap.querySelector('.jdgm-form__fieldset[aria-label="Rating"]');
    if (!ratingFieldset) return;

    var jdgmStars = formWrap.querySelectorAll('.jdgm-form__rating .jdgm-star');
    var ratingInput = formWrap.querySelector('.jdgm-form__rating input[type="hidden"]');

    var container = document.createElement('div');
    container.className = 'testimonials-review-modal__stars-overlay';

    var starSVG = '<svg viewBox="0 0 20 20"><path class="star-fill" d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.49L10 13.77 5.06 16.7l.94-5.49-4-3.9 5.53-.8L10 1.5z"/></svg>';

    for (var i = 0; i < 5; i++) {
      var wrapper = document.createElement('span');
      wrapper.innerHTML = starSVG;
      var svg = wrapper.firstChild;
      svg.dataset.value = i + 1;
      container.appendChild(svg);
    }

    // Insert after the "Rating" label
    var label = ratingFieldset.querySelector('label');
    if (label) {
      label.insertAdjacentElement('afterend', container);
    } else {
      ratingFieldset.prepend(container);
    }

    function setRating(value) {
      var svgs = container.querySelectorAll('svg');
      for (var j = 0; j < svgs.length; j++) {
        if (j < value) {
          svgs[j].classList.add('active');
        } else {
          svgs[j].classList.remove('active');
        }
      }
      // Sync with Judge.me's hidden input
      if (ratingInput) ratingInput.value = value;
      // Also click the corresponding Judge.me star to trigger their internal state
      if (jdgmStars[value - 1]) jdgmStars[value - 1].click();
    }

    container.addEventListener('click', function (e) {
      var svg = e.target.closest('svg');
      if (svg && svg.dataset.value) {
        setRating(parseInt(svg.dataset.value, 10));
      }
    });
  }

  /**
   * Clean up Judge.me form labels and placeholders inside the modal.
   */
  function cleanupFormLabels(formWrap) {
    if (!formWrap) return;

    // Swap "Display name" placeholder to "Your Name"
    var nameInput = formWrap.querySelector('input[placeholder="Display name"]');
    if (nameInput) nameInput.placeholder = 'Your Name';

    // Swap email placeholder
    var emailInput = formWrap.querySelector('input[placeholder="Your email address"]');
    if (emailInput) emailInput.placeholder = 'your@email.com';

    // Hide the broken "(displayed publicly like )" preview span
    var previewSpan = formWrap.querySelector('.jdgm-author-name-preview, .jdgm-form__author-name-preview');
    if (previewSpan) previewSpan.style.display = 'none';

    // Also find by text content if class doesn't match
    var allSpans = formWrap.querySelectorAll('span, small');
    for (var i = 0; i < allSpans.length; i++) {
      if (allSpans[i].textContent.indexOf('displayed publicly') >= 0) {
        allSpans[i].style.display = 'none';
      }
    }

    // Find the label that says "Display name" and simplify
    var labels = formWrap.querySelectorAll('label');
    for (var j = 0; j < labels.length; j++) {
      if (labels[j].textContent.indexOf('Display name') >= 0) {
        labels[j].textContent = 'Your Name';
      }
    }
  }

  /**
   * Review modal controller.
   * Opens/closes the Judge.me form modal and re-initializes the form widget if needed.
   */
  function initReviewModal() {
    var buttons = document.querySelectorAll('[data-open-review-modal]');
    var overlay = document.querySelector('[data-review-modal-overlay]');
    if (!buttons.length || !overlay) return;

    var starsBuilt = false;

    function open() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      if (!starsBuilt) {
        var formWrap = overlay.querySelector('.testimonials-review-modal__form-wrap');
        // Wait briefly for Judge.me to finish initializing the form
        setTimeout(function () {
          buildStarOverlay(formWrap);
          cleanupFormLabels(formWrap);
          starsBuilt = true;
        }, 200);
      }
    }

    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', open);
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    var closeBtn = overlay.querySelector('[data-review-modal-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        close();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
